import { render, staticRenderFns } from "./TemplateSegmentForm.vue?vue&type=template&id=2b04da81&scoped=true&"
import script from "./TemplateSegmentForm.vue?vue&type=script&lang=ts&"
export * from "./TemplateSegmentForm.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSegmentForm.vue?vue&type=style&index=0&id=2b04da81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b04da81",
  null
  
)

export default component.exports